// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3tdds","location":"Header_location__kKm6A"};